<script setup>
/* global axios */
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const error = ref('');

onMounted(async () => {
  try {
    const response = await axios.get(
      `/api/v1/accounts/${route.params.accountId}/oxam_ai/setup`
    );
    window.location.assign(response.data.redirect_url);
  } catch (e) {
    error.value =
      e.response?.data?.error || 'Unable to open AI Setup for this account.';
  }
});
</script>

<template>
  <main
    class="flex h-full items-center justify-center px-6 text-center text-sm text-n-slate-11"
  >
    <span v-if="error">{{ error }}</span>
    <span v-else>Opening AI Setup...</span>
  </main>
</template>
